import { render, staticRenderFns } from "./HoldingBonds.vue?vue&type=template&id=1f335f42&scoped=true&"
import script from "./HoldingBonds.vue?vue&type=script&lang=js&"
export * from "./HoldingBonds.vue?vue&type=script&lang=js&"
import style0 from "./HoldingBonds.vue?vue&type=style&index=0&id=1f335f42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f335f42",
  null
  
)

export default component.exports